'use client'

import Link from 'next/link'
import { useState, useEffect } from 'react'
import Image from 'next/image'

interface LogoProps {
  className?: string
  showText?: boolean
  size?: 'sm' | 'md' | 'lg'
}

// Logo de texto simple
const TextLogo = ({ className }: { className?: string }) => (
  <Image
    src='/images/logo_kuma4.png'
    alt='Kuma Montessori'
    width={140}
    height={36}
    priority
    fetchPriority='high'
    className={className}
  />
)

export const Logo: React.FC<LogoProps> = ({
  className = '',
  showText = true,
  size = 'md',
}) => {
  // Tamaños del logo según el prop size
  const sizeMap = {
    sm: { width: 80, height: 24 },
    md: { width: 120, height: 36 },
    lg: { width: 180, height: 48 },
  }

  const { width, height } = sizeMap[size]

  return (
    <Link
      href='/'
      className={`transition-opacity hover:opacity-80 ${className}`}
    >
      <TextLogo />
    </Link>
  )
}

// Componente solo para el icono (útil para mobile)
export const LogoIcon: React.FC<{
  size?: 'sm' | 'md' | 'lg'
  className?: string
}> = ({ size = 'md', className = '' }) => {
  const sizeMap = {
    sm: { width: 60, height: 18 },
    md: { width: 80, height: 24 },
    lg: { width: 120, height: 36 },
  }

  const { width, height } = sizeMap[size]

  return (
    <div className={`relative flex-shrink-0 ${className}`}>
      <TextLogo />
    </div>
  )
}

// Componente para el header principal
export const HeaderLogo: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  return (
    <Link href='/' className='transition-opacity hover:opacity-80'>
      <TextLogo />
    </Link>
  )
}

export default Logo
